<template>
  <div class="role-sync pa-2">
    <Typography variant="subtitle-1" class="mb-2">Role Sync</Typography>
    <Typography variant="body-2" class="mb-4">
      Pull the role configuration from the database and sync Auth0 roles to match. This will
      overwrite any manual changes to Auth0 roles.
    </Typography>
    <Button color="brandPrimary" :loading="loading" @click="syncRoles"> Sync Roles </Button>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";

import AuthService from "@/services/AuthService.js";

export default {
  name: "RoleSync",
  components: {
    Typography,
    Button,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    syncRoles() {
      this.loading = true;
      AuthService.syncRoles()
        .then((data) => {
          this.loading = false;
          if (data && data.success === true) {
            this.$store.dispatch("showSuccess", {
              message: "Roles synced successfully.",
            });
            return;
          }
          this.$store.dispatch("showError", {
            message: data?.error || "Failed to sync roles. Please try again later.",
          });
        })
        .catch(() => {
          this.loading = false;
          this.$store.dispatch("showError", {
            message: "Failed to sync roles. Please try again later.",
          });
        });
    },
  },
};
</script>

<style scoped>
.role-sync {
  max-width: 560px;
}
</style>
